/**
 * Centralized Mock Data Configuration
 *
 * This configuration defines all mock scenarios for the dashboard.
 * Each scenario includes:
 * - id: Unique identifier
 * - keywords: Array of keywords to match queries
 * - enabled: Flag to enable/disable the mock
 * - files: Paths to PDF and PPTX export files
 * - responseFile: Name of the JSON response file
 */

export interface MockScenario {
  id: string;
  keywords: string[];
  enabled: boolean;
  files: {
    pdf: string;
    powerpoint: string;
  };
  responseFile: string;
  description?: string;
}

export const MOCK_SCENARIOS: MockScenario[] = [
  {
    id: 'fab-stablecoin',
    keywords: ['fab stablecoin', 'bank stablecoin', 'aspire stablecoin'],
    enabled: true,
    files: {
      pdf: '/exports/fab-stablecoin/fab_stablecoin.pdf',
      powerpoint: '/exports/fab-stablecoin/Stablecoins_Launch_in_UAE_FAB.pptx'
    },
    responseFile: 'fab-stablecoin.json',
    description: 'FAB stablecoin strategy analysis'
  },
  {
    id: 'uk-expansion',
    keywords: ['uk expansion', 'uk market'],
    enabled: true,
    files: {
      pdf: '/exports/uk-expansion/UK_Expansion_FAB_Report.pdf',
      powerpoint: '/exports/uk-expansion/FAB_UK_Expansion.pptx'
    },
    responseFile: 'uk-expansion.json',
    description: 'FAB UK market expansion strategy'
  }
];

/**
 * Environment flag to enable/disable mock data system
 * Can be overridden by environment variable
 */
export const MOCK_DATA_ENABLED = process.env.REACT_APP_ENABLE_MOCK_DATA !== 'false';
